<template>
  <div>
    <!-- Start Product Area -->
    <div class="product_area section-pt-xl section-pb-xl bg-white">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section_title text-center">
              <h2>专业的医用清洗产品及服务供应商</h2>
              <p>PROFESSIONAL PROVIDER OF MEDICAL CLEANING PRODUCT & SERVICES</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Product Area -->
    <!-- Start Shipping Service -->
    <div class="shipping_service bg_image--3 ptb--80">
      <div class="shipping_wrap">
        <div class="row">
          <!-- Start Single -->
          <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
            <div class="service item_1">
              <div class="icon"><img src="../assets/img/icons/ship_icon_1.png" alt="icon" /></div>
              <div class="content">
                <h3>
                  多酶泡沫保湿剂
                  <br />
                  Humectant
                </h3>
                <p>含有独特保湿配方，能够保持器械湿润，预防生物负载黏附于外科器械和内镜表面</p>
              </div>
            </div>
          </div>
          <!-- End Single -->
          <!-- Start Single -->
          <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
            <div class="service item_2">
              <div class="icon"><img src="../assets/img/icons/ship_icon_2.png" alt="icon" /></div>
              <div class="content">
                <h3>
                  多酶清洗剂
                  <br />
                  Enzymatic Detergent
                </h3>
                <p>有效去除医疗器械表面脂肪、血液、糖类、蛋白质等生物负荷，同时防止器械生锈。 ‌</p>
              </div>
            </div>
          </div>
          <!-- End Single -->
          <!-- Start Single -->
          <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
            <div class="service item_3">
              <div class="icon"><img src="../assets/img/icons/ship_icon_3.png" alt="icon" /></div>
              <div class="content">
                <h3>
                  器械润滑剂
                  <br />
                  Lubricant
                </h3>
                <p>帮助在手术器械表面形成保护膜，防止器械表面氧化生锈，增加器械关节的灵活性。‌</p>
              </div>
            </div>
          </div>
          <!-- End Single -->
          <!-- Start Single -->
          <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
            <div class="service item_4">
              <div class="icon"><img src="../assets/img/icons/ship_icon_4.png" alt="icon" /></div>
              <div class="content">
                <h3>
                  器械除锈剂
                  <br />
                  Rust&scale remover
                </h3>
                <p>去除不锈钢材质的器械、托盘、水槽和手术推车上的锈渍、点蚀、白斑、硬水水垢和矿物沉淀。
                </p>
              </div>
            </div>
          </div>
          <!-- End Single -->
        </div>
      </div>
    </div>
    <!-- End Shipping Service -->
    <!-- Start Banner Area -->
    <div class="banner_area mt--20">
      <div class="row row--20">
        <div class="col-lg-4 col-sm-6 col-12">
          <div class="banner">
            <div class="thumb">
              <a href="#"><img src="../assets/img/banner/banner-1.jpg" alt="banner img" /></a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-12">
          <div class="banner">
            <div class="thumb">
              <a href="#"><img src="../assets/img/banner/banner-2.jpg" alt="banner img" /></a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-12">
          <div class="banner">
            <div class="thumb">
              <a href="#"><img src="../assets/img/banner/banner-3.jpg" alt="banner img" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner Area -->
    <!-- Start Product Area -->
    <div class="product_area section-pt-xl section-pb-xl bg-white">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section_title text-center">
              <h2>产品推荐</h2>
              <p>PROMOTIONS</p>
            </div>
          </div>
        </div>
        <div class="row mt--20">
          <!-- Start Single Product -->
          <div class="col-lg-2 col-xl-2 col-sm-6 col-6" v-for="item in promoteProducts" :key="item.pk">
            <div class="product">
              <div class="thumb">
                <a href="single-product.html"><img :src="$domainPrefix + item.thumb" alt="product img"
                    style="width: auto;" /></a>
                <div class="product_action" style="padding: 15px;">
                  <h4 style="font-size: 1rem;">
                  <b-link :to="'/procont/' + item.pk + '/'"> {{ item.title }} <br><br>查看详情</b-link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <!-- End Single Product -->
        </div>
      </div>
    </div>
    <!-- End Product Area -->
    <!-- Start CounteUp Area -->
   <div class="counterup_area mb--50 mt--50">
      <div class="counterup_wrapper">
        <div class="container bg_image--2">
          <div class="row">
            <div class="col-lg-12">
              <div class="counter_content_inner">
                <div class="counter_content">
                  <div class="thumb"><img src="../assets/img/product/coundown_pro_img.png" alt="banner images" /></div>
                  <div class="content">
                    <h2>康濯 &reg;</h2>
                    <h3>医用清洗剂</h3>
                    <b-link to="/prod">了解详情</b-link>
                  </div>
                </div>
<!--                <div id="js-clock" class="counterup_count">
                  <div class="box">
                    <span id="js-clock-days">00</span>
                    Days
                  </div>
                  <div class="box">
                    <span id="js-clock-hours">00</span>
                    Hours
                  </div>
                  <div class="box">
                    <span id="js-clock-minutes">00</span>
                    Minutes
                  </div>
                  <div class="box">
                    <span id="js-clock-seconds">00</span>
                    Seconds
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End CounteUp Area -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        promoteProducts: []
      }
    },
    methods: {
      // 按钮跳转链接
      jumpTo: function(path) {
        // this.$store.dispatch('setMainNav', '/about')
        this.$router.push({
          path: path
        })
      }
    },
    created() {
      // 获取推荐产品清单
      let that = this
      this.$axios
        .get('/api/getpromoted/')
        .then(function(response) {
          that.promoteProducts = response.data
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    mounted() {
      // this.$store.dispatch('setMainNav', this.$route.fullPath)
      // (function() {
      //   var deadline = '2029-12-31 00:00'

      //   function pad(num, size) {
      //     var s = '0' + num
      //     return s.substr(s.length - size)
      //   }

      //   function getTimeRemaining(endtime) {
      //     var t = Date.parse(endtime) - Date.parse(new Date())
      //     var seconds = Math.floor((t / 1000) % 60)
      //     var minutes = Math.floor((t / 1000 / 60) % 60)
      //     var hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      //     var days = Math.floor(t / (1000 * 60 * 60 * 24))

      //     return {
      //       total: t,
      //       days: days,
      //       hours: hours,
      //       minutes: minutes,
      //       seconds: seconds
      //     }
      //   }

      //   function clock(id, endtime) {
      //     var days = document.getElementById(id + '-days')
      //     var hours = document.getElementById(id + '-hours')
      //     var minutes = document.getElementById(id + '-minutes')
      //     var seconds = document.getElementById(id + '-seconds')
      //     var timeinterval = setInterval(function() {
      //       var t = getTimeRemaining(endtime)

      //       if (t.total <= 0) {
      //         clearInterval(timeinterval)
      //       } else {
      //         days.innerHTML = pad(t.days, 2)
      //         hours.innerHTML = pad(t.hours, 2)
      //         minutes.innerHTML = pad(t.minutes, 2)
      //         seconds.innerHTML = pad(t.seconds, 2)
      //       }
      //     }, 1000)
      //   }
      //   clock('js-clock', deadline)
      // })()
    }
  }
</script>

<style></style>
